export const InvestorReportingMediaType = {
  SLIDESHOW: 'SLIDESHOW',
  VIDEO: 'VIDEO',
};
export const status = {
  SUBMITTED: 'SUBMITTED',
  DRAFT: 'DRAFT',
};
